module.exports = __webpack_public_path__ + "media/images/afiliados3-356d525779c056552aefc8b0e9f85150.svg";